import React, { useState, Fragment, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
// import logo from '../../../assets/images/endless-logo.png';
import Language from './language';
import UserMenu from './userMenu';
import Notification from './notification';
import SearchHeader from './searchHeader';
import { Link } from 'react-router-dom';
import { AlignLeft, Maximize, Bell, MessageCircle, MoreHorizontal } from 'react-feather';
import {
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Dropdown
} from "reactstrap";
import { withRouter } from "react-router";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import moment from "moment";
import request, { NodeURL, socket, socket_notify } from "../../../api/api";
import noticloseIcon from "../../../images/candidate/close.svg";
import ReactTooltip from "react-tooltip";

const Header = (props) => {
	const [sidebar, setSidebar] = useState(false);
	const [rightSidebar, setRightSidebar] = useState(true);
	const [headerbar, setHeaderbar] = useState(true);
	const [header_drop, setHeaderdrop] = useState(false);
	const [unreadcount, setUnreadcount] = useState(0);
	const [notify, setNotify] = useState([]);

	const isDesktopOrLaptop = useMediaQuery({
		query: '(min-width: 1224px)'
	})

	const openCloseSidebar = (e) => {
		e.preventDefault()
		if (sidebar) {
			isDesktopOrLaptop && setSidebar(!sidebar)
			document.querySelector(".page-main-header").classList.remove('open');
			document.querySelector(".page-sidebar").classList.remove('open');
		} else {
			isDesktopOrLaptop && setSidebar(!sidebar)
			document.querySelector(".page-main-header").classList.add('open');
			document.querySelector(".page-sidebar").classList.add('open');
		}
	}

	function showRightSidebar() {
		if (rightSidebar) {
			setRightSidebar(!rightSidebar)
			document.querySelector(".right-sidebar").classList.add('show');
		} else {
			setRightSidebar(!rightSidebar)
			document.querySelector(".right-sidebar").classList.remove('show');
		}
	}

	//full screen function
	function goFull() {
		if ((document.fullScreenElement && document.fullScreenElement !== null) ||
			(!document.mozFullScreen && !document.webkitIsFullScreen)) {
			if (document.documentElement.requestFullScreen) {
				document.documentElement.requestFullScreen();
			} else if (document.documentElement.mozRequestFullScreen) {
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullScreen) {
				document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
			}
		} else {
			if (document.cancelFullScreen) {
				document.cancelFullScreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen();
			}
		}
	}

	let recent_notify = () => {
		request({
			url: '/employee/get/recent/notify',
			method: 'POST',
			data: { limit: 10 }
		}).then(res => {
			if (res && +res.status === 1) {
				setTimeout(() => {
					setNotify([...res.response]);
					setUnreadcount(res.unreadcount || 0);
				}, 1000);
			}
		}).catch(err => {
			console.log(`err is ${err}`);
		})
	};

	useEffect(() => {
		recent_notify();
		socket.on('notifications_application_form_submnit', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data._id) {
					if (String(token.user_id) === String(data._id)) {
						// recent_notify();
					}
				}
			}
		});

		socket.on('notifications_application_form_status', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data._id) {
					if (String(token.user_id) === String(data._id)) {
						recent_notify();
					}
				}
			}
		});

		socket_notify.on('web notification', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data.username && data.username.length > 0) {
					if (String(token.user_id) === String(data.username)) {
						// recent_notify();
					}
				}
			}
		});

		socket_notify.on('web_notification', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data.username && data.username.length > 0) {
					if (String(token.user_id) === String(data.username)) {
						// recent_notify();
					}
				}
			}
		});

		socket.on('notifications_todo', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data._id && data._id.length > 0) {
					if (String(token.user_id) === String(data._id)) {
						// recent_notify();
					}
				}
			}
		});

		socket.on('recruitment_notify', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data._id && data._id.length > 0) {
					if (String(token.user_id) === String(data._id)) {
						// recent_notify();
					}
				}
			}
		});

		socket.on('notifications', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data._id && data._id.length > 0) {
					if (String(token.user_id) === String(data._id)) {
						// recent_notify();
					}
				}
			}
		});

		socket.on('candidate_notify', (data) => {
			const tokenAgency = localStorage.getItem("APUSEC");
			if (tokenAgency) {
				const token = jwt_decode(tokenAgency);
				if (token && token.user_id && data && data._id) {
					if (String(token.user_id) === String(data._id)) {
						// recent_notify();
					}
				}
			}
		});
		return () => {
			recent_notify();
		}
	}, [])

	const header_Click = (e) => {
		setHeaderdrop(!header_drop);
	};

	const redirect_to = (evt, item) => {
		evt.preventDefault();
		evt.stopPropagation();
		if (item && item.readingStatus !== 1) {
			mark_read(item._id);
		}
		return props.history.push('/profile/viewprofile')
	};

	let markallasread = (event) => {
		event.preventDefault();
		request({
			url: "/employee/notification/markallasread",
			method: "POST"
		}).then(response => {
			if (response.status === 1) {
				// toast.success(response.response);
				// this.componentDidMount();
				recent_notify();
			} else {
				toast.error(response.response);
			}
		}).catch(error => {
			return toast.error(error);
		});
	}

	const clear_notify = (evt, id) => {
		evt.preventDefault();
		evt.stopPropagation();
		request({
			url: "/employee/notification/delete/individual",
			method: "POST",
			data: { _id: id }
		}).then(response => {
			if (response.status === 1) {
				// setTimeout(() => {
				//   get_notify();
				// }, 1500);
				recent_notify();
			}
		}).catch(error => {
			return toast.error(error);
		});
	};

	const mark_as_read = (evt, id) => {
		evt.preventDefault();
		evt.stopPropagation();
		request({
			url: "/employee/notification/markasread",
			method: "POST",
			data: { _id: id }
		}).then(response => {
			if (response && +response.status === 1) {
				// setTimeout(() => {
				//   get_notify();
				// }, 1500);
				recent_notify();
			}
		}).catch(error => {
			return toast.error(error);
		});
	};

	const mark_read = (id) => {
		request({
			url: "/employee/notification/markasread",
			method: "POST",
			data: { _id: id }
		}).then(response => {
			// setTimeout(() => {
			//   get_notify();
			// }, 1500);
			if (response && +response.status === 1) {
				// setTimeout(() => {
				//   get_notify();
				// }, 1500);
				recent_notify();
			}
		}).catch(error => {
			return toast.error(error);
		});
	};

	const mark_as_unread = (evt, id) => {
		evt.preventDefault();
		evt.stopPropagation();
		request({
			url: "/employee/notification/markas_un_read",
			method: "POST",
			data: { _id: id }
		}).then(response => {
			if (response.status === 1) {
				// setTimeout(() => {
				//   get_notify();
				// }, 1500);
				recent_notify();
			}
		}).catch(error => {
			return toast.error(error);
		});
	};

	let continue_form = () => {
		return props.history.push('/notification/list')
	};

	let get_fuill_notify = () => {
		return (
			<>
				<li style={{ cursor: 'pointer' }}><h2>Notification <span className="badge badge-pill badge-primary pull-right">{unreadcount}</span></h2></li>
				<li style={{ cursor: 'pointer' }} className="marked-cates"> <span><a onClick={(e) => markallasread(e)}> Mark all as read </a></span></li>
				<div style={{ cursor: 'pointer' }} className="notifi-scroll">

					{/* <DropdownItem> */}
					{
						notify.map((item, index) => (
							<li className={item && item.readingStatus === 1 ? '' : "unread"} key={index} onClick={(e) => redirect_to(e, item)} style={{ cursor: 'pointer' }}>
								<div className="media" >
									<div className="media-body">
										<h6 className="mt-0">
											<div className="profile-img notification-img">
												{String(item.action) === 'application-form-submit' ? 'AF' :
													String(item.action) === 'application-form-statusr' ? 'AF' :
														String(item.action) === 'interview_schedule' ? 'IV' : 'AF'
												}</div>
										</h6>
										<div className="notifi-text">
											<p className="mb-0">{item.message}</p>
											{item.raw_data && item.raw_data.notes && item.raw_data.notes !== '' ? <p className="mb-0">{item.raw_data.notes}</p>: null}
											<span>{`${moment(new Date(item.createdAt)).format('DD-MM-YYYY')} at ${moment(new Date(item.createdAt)).format('HH:MM')}`}</span>
										</div>
										<div className="notifi-close">
											<a onClick={(e) => { clear_notify(e, item._id) }}><img src={noticloseIcon} data-tip data-for="clearTip" /></a>
											<ReactTooltip id="clearTip" place="bottom" effect="solid">  Clear Notification  </ReactTooltip>
											{
												item && item.readingStatus === 1 ?
													<>
														<button onClick={(e) => { mark_as_unread(e, item._id) }} className={item && item.readingStatus === 1 ? 'unread-color' : ""} data-tip data-for={item && item.readingStatus === 1 ? "readTip" : 'unreadTip'}><label></label></button>
														<ReactTooltip id={item && item.readingStatus === 1 ? "readTip" : 'unreadTip'} place="left" effect="solid">
															Mark as unread  </ReactTooltip>
													</> :
													<>
														<button onClick={(e) => { mark_as_read(e, item._id) }} className={item && item.readingStatus === 1 ? 'unread-color' : ""} data-tip data-for={item && item.readingStatus === 1 ? "readTip" : 'unreadTip'}><label></label></button>
														<ReactTooltip id={item && item.readingStatus === 1 ? "readTip" : 'unreadTip'} place="left" effect="solid">
															Mark as read  </ReactTooltip>
													</>
											}
										</div>
									</div>
								</div>
							</li>
						))
					}
					{/* </DropdownItem> */}
				</div>
				<li style={{ cursor: 'pointer' }} className="txt-dark"><a onClick={(e) => { continue_form(e) }}>All notification </a></li>
			</>
		)
	};

	let get_no_records = () => {
		return (
			<div className="notifi-scroll">
				<li><h2>Notification <span className="badge badge-pill badge-primary pull-right">{unreadcount}</span></h2></li>
				<DropdownItem>
					<li className="txt-dark">No records found </li>
				</DropdownItem>
			</div>
		)
	};

	return (
		<Fragment>
			<div className="page-main-header" >
				<div className="main-header-right row">
					<div className="main-header-left d-lg-none">
						<div className="logo-wrapper">
							<Link to="/dashboard/default">
								{/* <img className="img-fluid" src={logo} alt="" /> */}
							</Link>
						</div>
					</div>
					<div className="mobile-sidebar d-block">
						<div className="media-body text-right switch-sm">
							<label className="switch">
								<a href="" onClick={(e) => openCloseSidebar(e)}>
									<AlignLeft />
								</a>
							</label>
						</div>
					</div>
					<div className="nav-right col p-0">
						<ul className={`nav-menus ${headerbar ? '' : 'open'}`}>
							<li>
								{/* <SearchHeader /> */}
							</li>
							<li>
								<a onClick={goFull} className="text-dark" href="#!">
									<Maximize />
								</a>
							</li>
							{/* <li className="onhover-dropdown">
								<a className="txt-dark" href="#javascript">
								<h6>EN</h6></a>
								<Language />
							</li> */}
							<li className="header-gal tooltip-header">
								<UncontrolledDropdown>
									<DropdownToggle className="btn-sm btn-info">
										<svg width="24" height="24" viewBox="0 0 24 24"
											focusable="false" role="presentation">
											<path d="M6.485 17.669a2 2 0 0 0 2.829 0l-2.829-2.83a2 2 0 0 0 0 2.83zm4.897-12.191l-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.048 5.048 0 0 0 .64-6.356 1.01 1.01 0 1 0-1.354-1.494c-.023.025-.046.049-.066.075a5.043 5.043 0 0 0-2.788-.84 5.036 5.036 0 0 0-3.57 1.478z" fill="currentColor" fillRule="evenodd">
											</path></svg>
										<span className="notification-count"> {unreadcount} </span>
										<span className="tooltiptext-header"> Notification </span>
									</DropdownToggle>
									<DropdownMenu>
										{/* <Notification /> */}
										<div>
											<ul className={`notification-dropdown onhover-show-div active p-0`}>
												{
													notify && notify.length > 0 ? get_fuill_notify() : get_no_records()
												}
											</ul>
										</div>
									</DropdownMenu>
								</UncontrolledDropdown>
							</li>

							{/* <li>
                <a href="javascript" onClick={showRightSidebar}>
                  <MessageCircle />
                  <span className="dot"></span>
                </a>
              </li> */}
							<li className="userpro-spaces" onClick={header_Click}>
								<UserMenu show_hide={header_drop} />
							</li>
						</ul>
						<div className="d-lg-none mobile-toggle pull-right" onClick={() => setHeaderbar(!headerbar)}><MoreHorizontal /></div>
					</div>
					<script id="result-template" type="text/x-handlebars-template">
						<div className="ProfileCard u-cf">
							<div className="ProfileCard-avatar">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-airplay m-0"><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1">
								</path>
									<polygon points="12 15 17 21 7 21 12 15"></polygon>
								</svg>
							</div>
							<div className="ProfileCard-details">
								<div className="ProfileCard-realName"></div>
							</div>
						</div>
					</script>
					<script id="empty-template" type="text/x-handlebars-template">
						<div className="EmptyMessage">Your search turned up 0 results. This most likely means the backend is down, yikes!</div>
					</script>
				</div>
			</div>
		</Fragment>
	)
};
export default withRouter(Header);